import React, { useState } from 'react';
import './App.css';
import FileUpload from './components/FileUpload';
import UploadProgress from './components/UploadProgress';
import { useAuth } from "react-oidc-context";

function App() {
  const auth = useAuth();
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);

  // Replace with your actual values:
  const clientId = "7en21h66i5ss4kgjrvk9bofhp5";
  const cognitoDomain = "https://dentalpilotspa.auth.us-east-1.amazoncognito.com"; // your Cognito domain
  const logoutUri = "http://localhost:3000"; // or your production URL

  const signOutRedirect = () => {
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  const handleUploadProgress = (progress: number) => {
    setUploadProgress(progress);
  };

  const handleUploadComplete = (fileUrl: string) => {
    setUploadedFiles(prev => [...prev, fileUrl]);
    setIsUploading(false);
    setUploadProgress(0);
  };

  const handleUploadStart = () => {
    setIsUploading(true);
    setUploadProgress(0);
  };

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <div className="App">
        <div className="container">
          <header className="header">
            <h1>🦷 Dental Pilot</h1>
            <p>Secure File Upload to AWS S3</p>
          </header>
          
          <main className="main-content">
            <pre>Hello: {auth.user?.profile.email}</pre>
            <button onClick={signOutRedirect}>Sign out</button>
            <FileUpload 
              onUploadStart={handleUploadStart}
              onUploadProgress={handleUploadProgress}
              onUploadComplete={handleUploadComplete}
            />
            
            {isUploading && (
              <UploadProgress progress={uploadProgress} />
            )}
            
            {uploadedFiles.length > 0 && (
              <div className="uploaded-files">
                <h3>Recently Uploaded Files</h3>
                <ul>
                  {uploadedFiles.map((fileUrl, index) => (
                    <li key={index}>
                      <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                        {fileUrl.split('/').pop()}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </main>
        </div>
      </div>
    );
  }

  // Enhanced sign-in page with dental AI theme
  return (
    <div className="signin-container">
      <div className="signin-card">
        <div className="signin-graphic" aria-label="Dental AI graphic" role="img">
          🦷🤖
        </div>
        <h1>Dental Pilot AI</h1>
        <p className="signin-subtitle">Sign in to access secure dental AI file uploads</p>
        <button className="signin-btn" onClick={() => auth.signinRedirect()}>
          Sign in with your account
        </button>
      </div>
    </div>
  );
}

export default App; 